import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  search: {
    id: 'Table.search',
    defaultMessage: 'Search {label}',
    description: 'Search input placeholder',
  },
});